import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { Image } from "@react-three/drei";


const ImageTexture = props => {
  

  const texture = useRef(null)

  useFrame((state) => {
    texture.current.rotation.y += Math.sin(state.clock.elapsedTime) * 0.002
    texture.current.rotation.x += Math.cos(state.clock.elapsedTime) * 0.001
    // texture.current.rotation.x += Math.PI * delta * 0.1
  })

  return <Image ref={texture} url={process.env.PUBLIC_URL + '/assets/cube.png'} position={[0, -0.2, -1]} scale={5} />
}

export default ImageTexture